import { render, staticRenderFns } from "./bg-balls.vue?vue&type=template&id=bf6756d6&"
import script from "./bg-balls.vue?vue&type=script&lang=js&"
export * from "./bg-balls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports